import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch } from 'react-redux';
import _ from 'lodash';

import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import PropTypes from 'prop-types';

import {
    PageLayout,
    Header,
    // Mask,
    StartSection,
    InfoSection,
    FunctionSection,
    ProfressonalSection,
    WhySection,
    JoinSection,
    StartSectionTwo,
    Footer,
    PlanSection,
    BookSection,
    CommingSoonSection,
} from '../components/LandingPage';

import { bookSession } from '../services/';
import { alertError } from '../redux/stateActions';

import { validEmail, validPhone } from '../utils/regex';

import { getDomain } from '../utils/utils';

dayjs.extend(objectSupport);
dayjs.extend(isSameOrBefore);

const LandingPage = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const mdUp = useMediaQuery(theme.breakpoints.up('sm'));
    const lgUp = useMediaQuery(theme.breakpoints.up('md'));
    const xlUp = useMediaQuery(theme.breakpoints.up('lg'));

    const [selectedTab, setSelectedTab] = useState(0);

    const tabsChangeHandler = (newValue, anchor) => {
        window.history.pushState({}, '/', "/" );
        setSelectedTab(newValue);

        if (anchor) {
            const element = document.getElementById(anchor);

            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
        }
    };

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [inputValue, setInputValue] = useState({
        fullname: '',
        phoneNumber: '',
        email: '',
        date: null,
        time: '',
    });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const pageValue = params.get('page');
        if (pageValue === 'commingsoon') {
            setSelectedTab(4);
        }
    }, []);

    const handleChange = (e) => {
        const newInputValue = { ...inputValue };
        const value = e.target.value;
        const name = e.target.name;
        newInputValue[name] = value;
        setInputValue(newInputValue);

        setErrors(errors.filter((error) => error.property !== name));
    };

    const handleDateChange = (date) => {
        const newInputValue = { ...inputValue };
        newInputValue['date'] = date;
        setInputValue(newInputValue);

        setErrors(errors.filter((error) => error.property !== 'date' && error.property !== 'time'));
    };

    const handleTimeChange = (time) => {
        const newInputValue = { ...inputValue };
        newInputValue['time'] = time;
        setInputValue(newInputValue);

        setErrors(errors.filter((error) => error.property !== 'date' && error.property !== 'time'));
    };

    const handleSubmit = async () => {
        const newErrors = [];

        if (inputValue.fullname === '') {
            newErrors.push({
                property: 'fullname',
                message: 'Please provide a valid Name.',
            });
        }

        if (!validEmail.test(inputValue.email)) {
            newErrors.push({
                property: 'email',
                message: 'Please provide a valid email.',
            });
        }

        if (!validPhone.test(inputValue.phoneNumber)) {
            newErrors.push({
                property: 'phoneNumber',
                message: 'Please provide a Mobile Number.',
            });
        }

        if (inputValue.date === null) {
            newErrors.push({
                property: 'date',
                message: 'Please provide a valid Date.',
            });
        }

        if (inputValue.time === '') {
            newErrors.push({
                property: 'time',
                message: 'Please provide a valid Start Time.',
            });
        }

        if (
            dayjs(inputValue.date)
                .set({
                    hour: inputValue.time.split(':')[0],
                    minute: inputValue.time.split(':')[1],
                })
                .isSameOrBefore(dayjs())
        ) {
            newErrors.push({
                property: 'date',
                message: 'Session must be in the future.',
            });
            newErrors.push({
                property: 'time',
                message: 'Session must be in the future.',
            });
        }

        setErrors(newErrors);
        if (!_.isEmpty(newErrors)) return;

        const dateTime = dayjs(inputValue.date)
            .set('hour', inputValue.time.split(':')[0])
            .set('minute', inputValue.time.split(':')[1]);

        try {
            setLoading(true);

            const res = await bookSession({
                fullname: inputValue.fullname.trim(),
                phoneNumber: inputValue.phoneNumber,
                email: inputValue.email.trim(),
                date: dateTime.format('YYYY-MM-DD'),
                time: dateTime.format('HH:mm:ss'),
            });

            if (res.status === 200) {
                setLoading(false);

                setSelectedTab(3);
                setInputValue({
                    fullname: '',
                    phoneNumber: '',
                    email: '',
                    date: null,
                    time: '',
                });
            } else {
                throw new Error(res);
            }
        } catch (error) {
            setLoading(false);

            if (!_.isEmpty(error.response.data)) {
                dispatch(alertError(error.response.data.message));
            } else {
                dispatch(alertError(`Cannot book a session please try again later.`));
            }
        }
    };

    const handleToPatient = () => {
        window.location.href = `https://app.${getDomain(window.location.host)}/signin`;
    };

    const handleToProvider = () => {
        window.location.href = `https://app.${getDomain(window.location.host)}/provider/signin`;
    };

    const handleGoHome = () => {
        window.history.pushState({}, '/', "/" );
        setSelectedTab(0);
    };

    return (
        <PageLayout showBackgroundImage={selectedTab === 0}>
            {/* <div style={{ display: selectedTab === 0 ? 'block' : 'none' }}>
                <Mask />
            </div> */}

            <Header
                selectedTab={selectedTab}
                onSelectTab={tabsChangeHandler}
                handleToProvider={handleToProvider}
                handleGoHome={handleGoHome}
                mdUp={mdUp}
                lgUp={lgUp}
                xlUp={xlUp}
            />

            <div
                style={{
                    display: selectedTab === 0 ? 'block' : 'none',
                    paddingTop: lgUp ? 0 : '40px',
                }}
            >
                <StartSection
                    handleToProvider={handleToProvider}
                    mdUp={mdUp}
                    lgUp={lgUp}
                    xlUp={xlUp}
                />
                <InfoSection mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
                <FunctionSection mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
                <ProfressonalSection mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
                <WhySection mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
            </div>

            <div
                style={{
                    display: selectedTab === 1 ? 'block' : 'none',
                    paddingTop: lgUp ? 0 : '40px',
                }}
            >
                <PlanSection
                    handleToProvider={handleToProvider}
                    mdUp={mdUp}
                    lgUp={lgUp}
                    xlUp={xlUp}
                />
            </div>

            <div
                style={{
                    display: selectedTab === 2 || selectedTab === 3 ? 'block' : 'none',
                    paddingTop: lgUp ? 0 : '40px',
                }}
            >
                <BookSection
                    loading={loading}
                    inputValue={inputValue}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    handleTimeChange={handleTimeChange}
                    errors={errors}
                    onSubmit={handleSubmit}
                    selectedTab={selectedTab}
                    handleToProvider={handleToProvider}
                    setSelectedTab={setSelectedTab}
                    mdUp={mdUp}
                    lgUp={lgUp}
                    xlUp={xlUp}
                />
            </div>

            <div
                style={{
                    display: selectedTab === 4 ? 'block' : 'none',
                    paddingTop: lgUp ? 0 : '40px',
                }}
            >
                <CommingSoonSection    onSelectTab={tabsChangeHandler} mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
            </div>

            <div
                style={{
                    display: selectedTab === 4 ? 'none' : 'block',
                }}
            >
                <JoinSection
                    onSelectTab={tabsChangeHandler}
                    handleToPatient={handleToPatient}
                    handleToProvider={handleToProvider}
                    mdUp={mdUp}
                    lgUp={lgUp}
                    xlUp={xlUp}
                />
            </div>

            <div
                style={{
                    display: selectedTab === 4 ? 'none' : 'block',
                }}
            >
                <StartSectionTwo
                    onSelectTab={tabsChangeHandler}
                    handleToProvider={handleToProvider}
                    mdUp={mdUp}
                    lgUp={lgUp}
                    xlUp={xlUp}
                />
            </div>

            <Footer onSelectTab={tabsChangeHandler} mdUp={mdUp} lgUp={lgUp} xlUp={xlUp} />
        </PageLayout>
    );
};

export default LandingPage;

LandingPage.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
};
